import "@mantine/core/styles.css";
import { MantineProvider } from "@mantine/core";
import { CookiesProvider } from "react-cookie";

import { createAIChatTheme } from "../../theme";
import AIChatClientContent from "../AIChatClientContent/AIChatClientContent";
import { Links, StringMap } from "@/utilities/types";

export interface AIChatClientProps {
	assistantID: string;
	vectorStoreId: string;
	siteName: string;
	siteTopics: string;
	assistantPersonality: string;
	appTitle: string;
	appTitleImageURL: string;
	welcomeHTML: string;
	promptSuggestions: string[];
	autolinkText?: Links;
	proxyURL: string;
	captchaRequired: boolean;
	captchaSiteKey: string;
	utmSource: string;
	utmMedium: string;
	utmCampaign: string;
	initialNonce: string;
	themeConf: StringMap;
}

export default function AIChatClient(props: AIChatClientProps) {
	return (
		<CookiesProvider>
			<MantineProvider theme={createAIChatTheme(props.themeConf)} defaultColorScheme="auto">
				<AIChatClientContent {...props} />
			</MantineProvider>
		</CookiesProvider>
	);
}
